import { render, staticRenderFns } from "./BooleanList.vue?vue&type=template&id=3d5096ae&"
import script from "./BooleanList.vue?vue&type=script&lang=js&"
export * from "./BooleanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports